import React from 'react';
import { Mail, Video, Key, Bell, Shield } from 'lucide-react';
import EmailSettings from './EmailSettings';
import ZoomSettings from './ZoomSettings';

export default function CommunicationSettings() {
  return (
    <div className="h-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Communication Settings</h2>
        <p className="mt-2 text-gray-600">Configure your communication preferences</p>
      </div>

      <div className="space-y-8">
        <EmailSettings />
        <ZoomSettings />
      </div>
    </div>
  );
}